import { MoneyMapCategorySection } from '@fruitful/money-map';
import {
    type DeepPartial,
    type MoneyMapAccountWithAccountDetails,
    MoneyMapCategory,
    type MoneyMapRuleWithAccountDetails,
    type MoneyMapWithRulesAndAccounts,
} from '@fruitful/types';
import { YStack } from 'smoothie';

import {
    PreviewSection,
    PreviewSectionIconMap,
} from '../../types/PreviewSection';
import { PreviewContainer } from './PreviewContainer';
import PreviewSectionHeader from './PreviewSectionHeader';

interface PreviewGoalsProps {
    moneyMap: MoneyMapWithRulesAndAccounts;
    accounts: MoneyMapAccountWithAccountDetails[];
    goalRules: Array<DeepPartial<MoneyMapRuleWithAccountDetails>>;
    goalsTotalCents: number | null;
}

export const PreviewGoals = ({
    moneyMap,
    accounts,
    goalRules,
    goalsTotalCents,
}: PreviewGoalsProps) => {
    return (
        <PreviewContainer>
            <YStack gap={8} maxWidth={640}>
                <PreviewSectionHeader
                    icon={PreviewSectionIconMap[PreviewSection.GOALS]}
                    title={PreviewSection.GOALS}
                />
                <MoneyMapCategorySection
                    category={MoneyMapCategory.GOALS}
                    moneyMap={moneyMap}
                    accounts={accounts}
                    totalAmountCents={goalsTotalCents}
                    rules={goalRules as MoneyMapRuleWithAccountDetails[]}
                    ruleVariant="summary"
                />
            </YStack>
        </PreviewContainer>
    );
};
